import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import Greeting from './pages/Greeting';
import AboutGTC from './pages/AboutGTC';
import Facilities from './pages/Facilities';
import ProgramList from './pages/ProgramList';
import ProgramDetail from './pages/ProgramDetail';
import NoticeList from './pages/NoticeList';
import NoticeDetail from './pages/NoticeDetail';
import MyPage from './pages/MyPage';
import DistanceEducationIntro from './pages/DistanceEducationIntro';
import DistanceEducationRules from './pages/DistanceEducationRules';
import AdminLayout from './components/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import CourseList from './pages/admin/CourseList';
import CourseForm from './pages/admin/CourseForm';
import StudentManagement from './pages/admin/StudentManagement';
import NoticeForm from './pages/admin/NoticeForm';
import { AuthProvider } from './contexts/AuthContext';
import { CourseProvider } from './contexts/CourseContext';
import { ApplicationProvider } from './contexts/ApplicationContext';
import { NoticeProvider } from './contexts/NoticeContext';

function App() {
  return (
    <AuthProvider>
      <CourseProvider>
        <ApplicationProvider>
          <NoticeProvider>
            <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<Home />} />

              {/* 센터소개 */}
              <Route path="/about/greeting" element={<Greeting />} />
              <Route path="/about/gtc" element={<AboutGTC />} />
              <Route path="/about/facilities" element={<Facilities />} />

              {/* 교육과정 (Programs/Courses) */}
              <Route path="/programs" element={<ProgramList />} />
              <Route path="/programs/:id" element={<ProgramDetail />} />
              <Route path="/courses" element={<ProgramList />} />
              <Route path="/courses/:id" element={<ProgramDetail />} />

              {/* 공지사항 */}
              <Route path="/notice" element={<NoticeList />} />
              <Route path="/notice/:id" element={<NoticeDetail />} />

              {/* 마이페이지 */}
              <Route path="/mypage" element={<MyPage />} />

              {/* 원격평생교육원 */}
              <Route path="/distance-education/intro" element={<DistanceEducationIntro />} />
              <Route path="/distance-education/rules" element={<DistanceEducationRules />} />

              {/* Admin Routes */}
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="courses" element={<CourseList />} />
                <Route path="courses/new" element={<CourseForm />} />
                <Route path="courses/edit/:id" element={<CourseForm />} />
                <Route path="students" element={<StudentManagement />} />
                <Route path="notices/new" element={<NoticeForm />} />
                <Route path="notices/edit/:id" element={<NoticeForm />} />
              </Route>
            </Routes>
            </Router>
          </NoticeProvider>
        </ApplicationProvider>
      </CourseProvider>
    </AuthProvider>
  );
}

export default App;
